import { Dialog } from "@jugl-web/ui-components";
import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC, useCallback } from "react";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export interface UpdateTicketContactDialogProps {
  isOpen: boolean;
  currentContactName: string;
  nextContactName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const UpdateTicketContactDialog: FC<UpdateTicketContactDialogProps> = ({
  isOpen,
  currentContactName,
  nextContactName,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslations();

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onClose, onConfirm]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className="flex w-[480px] flex-col overflow-hidden rounded-2xl p-10"
    >
      <span className="font-secondary text-[22px] font-bold text-dark">
        {t({
          id: "client-support-page.update-ticket-customer-emoji",
          defaultMessage: "💼 Update Ticket Customer",
        })}
      </span>
      <span className="mt-2.5 font-secondary text-sm leading-[21px] text-dark-700">
        {t(
          {
            id: "client-support-page.update-ticket-customer-description",
            defaultMessage:
              "Once you confirm this action, the ticket will be removed from {currentContact} account, and associated with {nextContact} instead",
          },
          {
            currentContact: (
              <span className="font-medium text-primary">
                {currentContactName}
              </span>
            ),
            nextContact: (
              <span className="font-medium text-primary">
                {nextContactName}
              </span>
            ),
          }
        )}
      </span>
      <div className="mt-14 flex items-center gap-4">
        <Button onClick={onClose} variant="tertiary" className="w-[140px]">
          {t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          })}
        </Button>
        <Button
          onClick={handleConfirm}
          iconEnd={<ArrowRightIcon />}
          className="flex-1"
        >
          {t({
            id: "common.confirm",
            defaultMessage: "Confirm",
          })}
        </Button>
      </div>
    </Dialog>
  );
};
